import Vue from 'vue'
import Cookies from 'js-cookie'

export function switchModalState(name) {
  var state = {};
};

export function getTemplateByName(name) {
  return $('#' + name + '-template').html();
};

export function ajax(opt) {
  var _opt = $.extend({
    url : '',
    type : 'get',
    async: true,//使用同步的方式,true为异步方式
    data : {},
    success : function (res) {

    },
    fail : function (res) {
      alert(res.message);
    },
    error : function (e) {

    },
    mock : null,
    urlext : ''                 // 追加在 url后的参数, urlext 的参数值必须为 data 中 存在的 key, 该key 对应的 value 会被追加到url中
  }, opt);
  if (_opt.urlext && _opt.data[_opt.urlext]) {
    _opt.url = _opt.url + '/' + _opt.data[_opt.urlext];
  }
  // 启用模拟数据
  console.info(_opt);
  if (Vue.SiteConfig.env && _opt.mock) {
    _opt.success(_opt.mock);
    return true;
  }
  $.ajax({
    url: Vue.SiteConfig.api_domain + _opt.url,
    headers: {'Authorization': Cookies.get('token')}	,
    type: _opt.type,
    async: _opt.async,
    data: _opt.data,
    dataType: 'json',
    success:function (res) {
      console.info(opt.url + " : " + '数据加载成功');
      console.info(res);
      if (res.status == 200) {
        console.info('成功');
        _opt.success(res);
      } else {
        if (res.status == 401) {             // token 失效或错误
          alert('Token 过期, 请重新登录!');
          // this.$vDialog.alert('Token 过期, 请重新登录!', null, {messageType: 'error'});
          // app.loginOut();                 // 退出登录
          // app.login();                    // 登录框
        } else {
          console.info('测试');
          _opt.fail(res);
        }
      }
    },
    error: function (e) {
      console.info('错误 : '+JSON.stringify(e));
      // alert('Token 过期, 请重新登录!');
      _opt.error(e);
    }
  });
};

export function timeline(op) {
  if (!op.$box) {
    return false;
  }
  var $from = op.$box.find('.from-time');
  var $to = op.$box.find('.to-time');

  var selectTimeline= function () {
    var data = {
      from : $from.val(),
      to : $to.val()
    };
    if ($from.val() && $to.val()) {
      if (new Date(data.from).getTime() > new Date(data.to).getTime()) {
        alert('结束时间必须比开始时间晚!');
        // this.$vDialog.alert('结束时间必须比开始时间晚!', null, {messageType: 'info'});
        return false;
      }
      op.callback && op.callback(data);
    }
  };

  var nowTemp = new Date();
  var now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);

  $from.datepicker({
    onRender: function(date) {
      return date.valueOf() < now.valueOf() ? 'disabled' : '';
    }
  }).on('changeDate', function(ev) {
    selectTimeline();
    setTimeout(function () {
      op.trigger && op.trigger.dropdown('toggle');
    }, 0);
  }).data('datepicker');

  $to.datepicker({
    onRender: function(date) {
      return date.valueOf() <= $from.date.valueOf() ? 'disabled' : '';
    }
  }).on('changeDate', function(ev) {
    selectTimeline();
    setTimeout(function () {
      op.trigger && op.trigger.dropdown('toggle');
    }, 0);
  }).data('datepicker');
};


export function toggleModal(name) {
  $('#Modal_' + name).modal('toggle');
};
export function showModal(name) {
  if (name=='wechatpay') {
    $('#Modal_' + name).modal({backdrop: 'static', keyboard: false});
  }


  $('.modal').css('z-index', '1');
  $('#Modal_' + name).css('z-index', '1200').modal('show');
};
export function hideModal(name) {
  $('#Modal_' + name).modal('hide');
};

export function showAlert(name) {
  $('#Alert_' + name).show();
};
export function hideAlert(name) {
  $('#Alert_' + name).hide();
};

export function getS4() {
  return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
};
export function getGuid() {
  return (getS4()+getS4()+"-"+getS4()+"-"+getS4()+"-"+getS4()+"-"+getS4()+getS4()+getS4());
};

export function readFile(file, callback){
  if(!/image\/\w+/.test(file.type)){
    alert("文件必须为图片！");
    // this.$vDialog.alert("文件必须为图片！", null, {messageType: 'error'});
    return false;
  }
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function(e){
    callback(this.result);
  }
};

export function ImageProgress(op) {
  var _this = this;
  var _op = $.extend({
    file : null,
    add : function () {},
    delete : function () {}
  }, op);
  _this.file = _op.file;          // 每个 progress 对应的 file 对象
  _this.fileProgressID = _this.file.id;
  _this.$list = {};

  /**
   * 删除当前进度条
   */
  _this.deleteProgress = function () {
    _this.$list.remove();
    _op.delete.call(_this);
  };
  /**
   * 插入进度条
   */
  _this.createProgress = function () {
    var html = '<li class="file-progress imgfile-progress">' +
      '<input class="imgUrl" name="imgUrl" value="">' +
      '<div class="file-info">' +
      '<i class="icon-' + 'jpg' + '-small"></i>' +
      '<p>' + _this.file.name + '</p>' +
      '</div>' +
      '<div class="progress-wrapper">' +
      '<div data-progress="" class="progress">' +
      '<div class="progress-bar"></div><span class="progress-bar-info">0%</span>' +
      '</div>' +
      '<div class="progress-tip">上传失败, <span class="try-again">重试</span></div>' +
      '</div>' +
      '<i class="icon-close-big delete-trigger"></i>' +
      '</li>';
    _this.$list = $(html).appendTo('#Modal_uploadimgpro .progress-lists ul');
    _this.$list.find('.delete-trigger').on('click', _this.deleteProgress);
    _op.add.call(_this);
  };
  /**
   * 动态更新进度条
   * @param percentage : 文件上传百分比
   * @param speed : 上传速率
   * @param chunk_size : 分块上传的块数
   */
  _this.setProgress = function (percentage, speed, chunk_size) {
    var $list = _this.$list;
    $list.find('.progress-bar-info').html(percentage + '%');
    $list.find('.progress-bar').css('width', percentage + '%');
    if (percentage == 100) {
      $list.find('.progress').addClass('end');
    }
  };

  _this.init = function () {
    _this.createProgress();
  };

  _this.init();
  return _this;
};

export function FileProgress(op) {
  var _this = this;
  var _op = $.extend({
    file : null,
    add : function () {},
    delete : function () {}
  }, op);
  _this.file = _op.file;          // 每个 progress 对应的 file 对象
  _this.fileProgressID = _this.file.id;
  _this.$list = {};

  /**
   * 删除当前进度条
   */
  _this.deleteProgress = function () {
    _this.$list.remove();
    _op.delete.call(_this);
  };
  /**
   * 插入进度条
   */
  _this.createProgress = function () {
    var html = '<li class="file-progress" id="' + _this.file.id + '">' +
      '<input type="hidden" name="name" value="">' +
      '<input type="hidden" name="size" value="">' +
      '<input type="hidden" name="totalPage" value="">' +
      '<input type="hidden" name="url" value="">' +
      '<input type="hidden" name="origin_url" value="">' +
      '<div class="file-info">' +
      '<i class="icon-' + _this.file.name.split('.').pop().toLocaleString() + '-small"></i>' +
      '<p>' + _this.file.name + '</p>' +
      '</div>' +
      '<div class="progress-wrapper">' +
      '<div data-progress="" class="progress">' +
      '<div class="progress-bar"></div><span class="progress-bar-info">0%</span>' +
      '</div>' +
      // '<div class="progress-tip">文件解析失败, <span class="try-again">重试</span></div>' +
      '</div>' +
      '<i class="icon-close-big delete-trigger"></i>' +
      '</li>';
    _this.$list = $(html).appendTo('#Modal_uploadfilepro .progress-lists ul');
    _this.$list.find('.delete-trigger').on('click', _this.deleteProgress);
    _op.add.call(_this);
  };
  /**
   * 动态更新进度条
   * @param percentage : 文件上传百分比
   * @param speed : 上传速率
   * @param chunk_size : 分块上传的块数
   */
  _this.setProgress = function (percentage, speed, chunk_size) {
    var $list = _this.$list;
    $list.find('.progress-bar-info').html(percentage + '%');
    $list.find('.progress-bar').css('width', percentage + '%');
    if (percentage == 100) {
      $list.find('.progress').addClass('load');
    }
  };

  _this.init = function () {
    _this.createProgress();
  };

  _this.init();
  return _this;
};

export function getIconExt(ext) {
  var classPre = '';
  switch (ext) {
    case 'doc' : return classPre + 'doc';
    case 'docx' : return classPre + 'doc';
    case 'xls' : return classPre + 'xls';
    case 'xlsx' : return classPre + 'xls';
    case 'ppt' : return classPre + 'ppt';
    case 'pptx' : return classPre + 'ppt';
    case 'pdf' : return classPre + 'pdf';
    case 'jpg' : return classPre + 'j';
    case 'png' : return classPre + 'j';
    case 'gif' : return classPre + 'j';
  }
};

// export function BaiduMap() {
//     var self = this;
//     self.$map = null;
//     // 创建地图
//     var _initMap = function(op){
//         // 创建Map实例
//         var level = op.level || 15;
//         self.$map = new BMap.Map(op.id);
//         if (op.city) {
//             self.$map.centerAndZoom(op.city, level);
//         } else if (op.point) {
//             self.$map.centerAndZoom(op.point, level);
//         } else if (op.lng && op.lat) {
//             self.$map.centerAndZoom(self.getPoint(op.lng, op.lat), level);
//         }
//     };
//
//     var _addControl = function () {
//         // 添加控件
//         self.$map.addControl(new BMap.MapTypeControl());   //添加地图类型控件
//         // self.$map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
//         // var top_left_control = new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT});// 左上角，添加比例尺
//         // var top_left_navigation = new BMap.NavigationControl();  //左上角，添加默认缩放平移控件
//         var top_right_navigation = new BMap.NavigationControl({anchor: BMAP_ANCHOR_TOP_RIGHT, type: BMAP_NAVIGATION_CONTROL_SMALL});                        //右上角，仅包含平移和缩放按钮
//         /*缩放控件type有四种类型:
//          BMAP_NAVIGATION_CONTROL_SMALL：仅包含平移和缩放按钮；BMAP_NAVIGATION_CONTROL_PAN:仅包含平移按钮；BMAP_NAVIGAT*/
//         // self.$map.addControl(top_left_control);
//         // self.$map.addControl(top_left_navigation);
//         self.$map.addControl(top_right_navigation);
//     };
//
//     self.center = function (op) {
//         var level = op.level || 15;
//         if (op.city) {
//             self.$map.centerAndZoom(op.city, level);
//         } else if (op.point) {
//             self.$map.centerAndZoom(op.point, level);
//         }
//     };
//
//     self.panTo = function (point) {
//         self.$map.panTo(point);     // 将某个点移动到地图中心
//     };
//
//     self.init = function(op){
//         _initMap(op);     // 初始化地图
//         _addControl();
//     };
//
//     // 获取当前定位
//     self.getLocation = function(callback, fail){
//         var geolocation = new BMap.Geolocation();
//         geolocation.getCurrentPosition(function(r){
//             console.info('getCurrentPosition status : ' + this.getStatus());
//             console.info(r);
//             if(this.getStatus() == BMAP_STATUS_SUCCESS){
//                 typeof callback == 'function' && callback(r);
//             }
//             else {
//                 console.info('failed'+this.getStatus());
//                 typeof fail == 'function' && fail(r);
//             }
//         },{enableHighAccuracy: true})
//     };
//
//     self.getIcon = function (url, width, height) {
//         return new BMap.Icon(url, new BMap.Size(width, height));
//     };
//
//     self.getPoint = function (lng, lat) {
//         return new BMap.Point(lng, lat);
//     };
//
//     self.addMarker = function (op) {
//         var marker;
//         console.info(op);
//         if (op.icon) {
//             marker = new BMap.Marker(op.point,{icon : op.icon});
//         } else {
//             marker = new BMap.Marker(op.point);
//         }
//         marker.data = op.data;
//         if (typeof op.listener == 'function') {
//             marker.addEventListener("click", op.listener);
//         }
//         self.$map.addOverlay(marker);
//         console.info(marker);
//     };
//
//     //清除覆盖物
//     self.remove_overlay = function(){
//         self.$map.clearOverlays();
//     };
//
//     // 计算地球上两点之间的距离
//     self.getDistance = function(lng1, lat1, lng2, lat2){
//         var pk = 180 / 3.14169;
//         var a1 = lat1 / pk;
//         var a2 = lng1 / pk;
//         var b1 = lat2 / pk;
//         var b2 = lng2 / pk;
//         var t1 = Math.cos(a1) * Math.cos(a2) * Math.cos(b1) * Math.cos(b2);
//         var t2 = Math.cos(a1) * Math.sin(a2) * Math.cos(b1) * Math.sin(b2);
//         var t3 = Math.sin(a1) * Math.sin(b1);
//         var tt = Math.acos(t1 + t2 + t3);
//         return parseInt(6371000 * tt);
//     };
//
//     return this;
// };

export function updateProgressBtn(boxId, btnId, type) {
  var $progress = $('#' + boxId + ' .file-progress');
  var checkClass = 'end';
  for (var i = 0; i < $progress.length; i++) {
    if (!$($progress[i]).find('.progress').hasClass(checkClass)) {
      $('#' + btnId).removeClass('btn-highlight');
      return false;
    }
  }
  $('#' + btnId).addClass('btn-highlight');
};

/**
 * 全局 Loading
 * @param status : true , 显示; false , 隐藏
 * @param delay
 */
export function loading(status, delay) {
  var html = '<div id="J_loadin_{time}" class="ajax-loading">Loading...</div>';
  $('.ajax-loading').remove();
  if (status) {
    html = html.replace('{time}', new Date().getTime());
    var bloading = $(html).appendTo('body');
    setTimeout(function () {
      bloading.remove();
    }, parseInt(delay) || 5000);
  }
};



// WEBPACK FOOTER //
// ./src/api/global.js